import { AreaLine, useIsMobile } from '@yes.technology/react-toolkit'

import { TopAreaLayoutType, TopAreaPositionType } from 'site/shared/types'

import useStyleMaps from 'site/Renderer/hooks/useStyleMap'

import CollapsibleMenu from './CollapsibleMenu/CollapsibleMenu'
import DesktopLanguageContainer from './LanguageMenu/DesktopLanguageContainer'
import Position from './Position'

import { StyledContainer } from './styles'
import { TopLineProps } from './TopLine.types'

enum PositionEnum {
  Position1 = 'position_1',
  Position2 = 'position_2',
  Position3 = 'position_3'
}

type RenderArea = {
  position?: TopAreaPositionType[]
  positionEnum?: PositionEnum
  isCenter?: boolean
}

export const renderArea = ({
  position,
  positionEnum,
  isCenter = false
}: RenderArea = {}) => (
  <div
    id={
      positionEnum === PositionEnum.Position3 ? 'navigation-right' : undefined
    }
    className={`d-flex gap-3 ${isCenter ? 'w-full' : ''}`}
  >
    {position?.map((component, index) => (
      <Position key={index} {...component} />
    ))}
  </div>
)

export const parseLayout = (
  layout?: TopAreaLayoutType | string
): TopAreaLayoutType | undefined => {
  let parsedData

  if (typeof layout === 'string') {
    try {
      parsedData = JSON.parse(layout) as TopAreaLayoutType
    } catch (error) {
      parsedData = {}
    }
  } else {
    parsedData = layout
  }

  return parsedData
}

const TopLine = ({ props }: TopLineProps) => {
  const layout = parseLayout(props.layout)

  const styleProp = useStyleMaps(props?.styleMap)

  const isMobile = useIsMobile()

  const placement = props.placement || 'default'

  const availableLanguages = props.available_languages

  if (!layout) return null

  if (isMobile) {
    return (
      <CollapsibleMenu
        layout={layout}
        availableLanguages={availableLanguages}
      />
    )
  }

  if (placement !== 'default') {
    return (
      <AreaLine
        className='navbar-expand-lg'
        leftAreaElement={renderArea({
          position: layout.position_1,
          positionEnum: PositionEnum.Position1
        })}
        centerAreaElement={renderArea({
          position: layout.position_2,
          positionEnum: PositionEnum.Position2,
          isCenter: true
        })}
        rightAreaElement={
          availableLanguages ? (
            <DesktopLanguageContainer availableLanguages={availableLanguages}>
              {renderArea({
                position: layout.position_3,
                positionEnum: PositionEnum.Position3
              })}
            </DesktopLanguageContainer>
          ) : (
            renderArea({
              position: layout.position_3,
              positionEnum: PositionEnum.Position3
            })
          )
        }
        alignment='left'
        colorScheme='white'
        heightClass='regular'
        placement={placement}
        style={styleProp}
      />
    )
  }

  return (
    <StyledContainer style={styleProp}>
      <AreaLine
        className='navbar-expand-lg'
        leftAreaElement={renderArea({
          position: layout.position_1,
          positionEnum: PositionEnum.Position1
        })}
        centerAreaElement={renderArea({
          position: layout.position_2,
          positionEnum: PositionEnum.Position2,
          isCenter: true
        })}
        rightAreaElement={renderArea({
          position: layout.position_3,
          positionEnum: PositionEnum.Position3
        })}
        alignment='left'
        colorScheme='white'
        heightClass='regular'
        placement={placement}
      />
    </StyledContainer>
  )
}

export default TopLine
